<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">   
          <div v-if="item.productType==2">
            <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
          </div>
          <div v-else class="contentDiv">
            <hotel-resource-left :productObj="item" :showTag="false" :rightAction="false" class="contentHead">
              <template v-slot:headRight>
                <div class="rightDiv">
                  <div class="cardContainer">
                    <i class="el-icon-star-off"></i>
                    <span class="btn">常用</span>
                  </div>
                  <div class="showCard-tag">
                    <div>
                      <i @click.stop="openPriceDetail(item)" :class="item.isOpen?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
                    </div>
                    <div>
                      <b>{{ item.price }}</b>
                      <b style="font-size:0.12rem;">{{ item.currency }}</b>
                      <label>起</label>
                    </div>
                  </div>
                </div>
              </template>
            </hotel-resource-left>
            <div class="contentContainer" v-if="item.isOpen">
              <div class="boxContainer1" v-for="(item1, index1) in item.stockListResults" :key="index1">
                <div class="firstLine">
                  <div class="item" style="width:2rem">
                    <el-tooltip :content="item1.productNameCn">
                      <b :title="item1.productNameCn" class="productName">{{ item1.productNameCn }}</b>
                    </el-tooltip>
                  </div>
                  <div class="item1" style="width:2.5rem">
                    <span class="label" v-for="(item,index) in item1.labels" :key="index">{{item}}</span>
                  </div>
                </div>
                <div class="firstLine" style="    margin-top: 0.1rem;">
                  <div class="tagBox">
                    <span class="tag" @click="changePrice(item,item1,item1)">{{ item1.priceList[0].price }}{{ item1.priceList[0].currency }}</span>
                    <el-input v-model="item1.checkNumber" style="width: 0.5rem" size="mini"></el-input>
                    <span>&nbsp;{{item1.priceList[0].priceCompany}}</span>
                  </div>
                  <div class="item3">
                    <span class="qiang" >抢</span>
                    <i class="el-icon-circle-plus-outline" @click="addBudget(item,item1)"></i>
                  </div>
                  <div>产品说明</div>
                </div>
              </div>
              <p style="text-align: right">
                <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
              </p>
            </div>
          </div>
        </div>
      </template>
    </stock>
    <create-product-dialog ref="createProduct" :keyStr="keyStr" :searchDate="searchObj.date"></create-product-dialog>
  </div>
</template>

<script>
import Stock from './stock.vue'
import Api from '@/components/Api/index.js'
import PlanApi from '@/components/Api/PlanApi.js'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import { refresh } from '../../js/function'
import createProductDialog from './addProductDialog/createProductDialog.vue'
export default {
  components:{Stock,hotelResourceLeft,createProductDialog},
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  data(){
    return{
      searchObj:{
        countryId:null,
        countryName:'',
        countryName1:'',
        date:null,
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:6,
      },
      dataList:[],
      keyStr:'',
    }
  },
  methods:{
    changePrice(item,item1,item2){
      this.$refs.createProduct.beforeOpen(item,item2,{})
    },
    postListData(type){
      if(this.checkState===6){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                var labels = []
                element.stockListResults.forEach(e=>{
                  var str = e.productNameCn.split(" ")
                  if(str.length>1&&labels.indexOf(str[0])==-1){
                    labels.push(str[0])
                  }
                })
                this.$set(element,'labels',labels)
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      } 
    },
    openPriceDetail(item){
      this.$set(item,'isOpen',!item.isOpen)
    },
    addBudget(item,item1){
      var arr = [{
        stockId:item1.stockId,
        stockNumber:item1.checkNumber
      }]
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:6,
        startLinkId:this.searchObj.countryId,
        startLinkName:this.searchObj.countryName==''?this.searchObj.countryName1:this.searchObj.countryName,
        linkType:0,
        productType:item.productType,
        resourceId:item.id,
        resourceNameCn:item.nameCn,
        resourceNameEn:item.nameEn,
        key:this.keyStr,
        details:arr
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentHead{
    border-bottom: 3px solid #db4e1a;
  }
  .contentContainer{
    .boxContainer1{
      padding: 0.1rem;
      .firstLine{
        display: flex;
        align-items: center;
        .tagBox{
          display: flex;
          align-items: center;
          margin-left: 2rem;
          .tag{
            color: #ff0000;
            font-weight: bold;
            font-size: 0.16rem;
            width: 0.9rem;
            cursor: pointer;
            text-decoration: underline;
          }
        }
        >div{
          margin-right: 0.05rem;
          .label{
            padding: 0.02rem 0.05rem;
            color: #fcca00;
            border: 1px solid #fcca00;
            margin-right: 0.05rem;
          }
        }
        .item3{
          display: flex;
          margin-left: 0.2rem;
          .qiang{
            font-size: 0.18rem;
            box-shadow: 0px 0px 4px 0px #333;
            border-radius: 50%;
            color: red;
            text-align: center;
            display: inline-block;
            width: 0.26rem;
            height: 0.26rem;
            line-height: 0.26rem;
            font-weight: bold;
            margin: 1px;
            vertical-align: middle;
            margin-right: 0.05rem;
          }
          >i{
            font-size: 0.28rem;
          }
        }
      }
    }
  }
}
.rightDiv{
  .cardContainer{
    background: #f1f4f4;
    width: 1.3rem;
    padding: 0.15rem 0.1rem;
    display: flex;
    i{
      width: 0.24rem;
      height: 0.24rem;
      border: 1px solid #ccc;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.12rem;
    }
    .btn{
      cursor: pointer;
      padding: 0.03rem 0.2rem;
      background: #c33246;
      color: #fff;
      margin-left: 0.14rem;
    }
  }
  .showCard-tag{
    padding: 0 0.04rem;
    height: 0.35rem;
    background: #db4e1a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    color: #fff; 
    >div{
      >i{
        font-size: 0.25rem;
      }
      >b{
        font-size: 0.18rem;
      }
      >label{      
        font-size: 0.12rem;
        padding-right: 3px;
      }
    }
  }
}
</style>